// extracted by mini-css-extract-plugin
export default {"container":"CrashScreen_container__4KzbW"};